module.exports = __webpack_public_path__ + "img/no-imagen.2ca88635.jpg";